import { __rest, __assign } from 'tslib';
import React from 'react';
import { SvgIcon } from '../SvgIcon/SvgIcon.esm.js';

var RowDensityStandardIcon = function (_a) {
    var props = __rest(_a, []);
    return (React.createElement(SvgIcon, __assign({}, props, { viewBox: "0 0 12 12" }),
        React.createElement("path", { d: "M0.75 8.10714H11.25C11.6625 8.10714 12 7.76482 12 7.34643C12 6.92804 11.6625 6.58571 11.25 6.58571H0.75C0.3375 6.58571 0 6.92804 0 7.34643C0 7.76482 0.3375 8.10714 0.75 8.10714ZM0.75 11.15H11.25C11.6625 11.15 12 10.8077 12 10.3893C12 9.97089 11.6625 9.62857 11.25 9.62857H0.75C0.3375 9.62857 0 9.97089 0 10.3893C0 10.8077 0.3375 11.15 0.75 11.15ZM0.75 5.06429H11.25C11.6625 5.06429 12 4.72196 12 4.30357C12 3.88518 11.6625 3.54286 11.25 3.54286H0.75C0.3375 3.54286 0 3.88518 0 4.30357C0 4.72196 0.3375 5.06429 0.75 5.06429ZM0 1.26071C0 1.67911 0.3375 2.02143 0.75 2.02143H11.25C11.6625 2.02143 12 1.67911 12 1.26071C12 0.842321 11.6625 0.5 11.25 0.5H0.75C0.3375 0.5 0 0.842321 0 1.26071Z" })));
};

export { RowDensityStandardIcon };
//# sourceMappingURL=RowDensityStandardIcon.esm.js.map
